var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('type-and-value-input',{attrs:{"item":_vm.item,"itemTypes":_vm.workTitleTypesVerbose,"upper":"","rules":"required","name":("title-" + (_vm.title.index))},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }